import React, { Component } from 'react';
import uuid from 'react-uuid'

import { AuthContext } from "../../components/Auth/AuthDataProvider.jsx";
import apiUtil from "../../api/apiUtil.jsx";
import wmsApi from "../../api/wmsApi.jsx";
import Api from "../../api/api.jsx";

import { 
  Box,
  Grid,
  Container,
  Divider,
  IconButton,
  CircularProgress,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';

import StickyPageHeader from '../../components/PageHeader/StickyPageHeader.jsx';
import Card from '../../components/Card/Card.jsx';
import CustomLabel from '../../components/CustomFields/CustomLabel.jsx';
import CustomInput from '../../components/CustomFields/CustomInput.jsx';
import CustomButton from '../../components/CustomFields/CustomButton.jsx';
import CustomTooltip from '../../components/Tooltip/CustomTooltip.jsx';
import CustomDialog from '../../components/Dialog/CustomDialog.jsx';
import CustomGuideStepper from '../../components/Stepper/CustomGuideStepper.jsx';

import CompanyAddressList from './Partial/CompanyAddressList.jsx';
import CompanyDepartmentList from './Partial/CompanyDepartmentList.jsx';
import CustomerAdminAccountForm from './Partial/CustomerAdminAccountForm.jsx';
import CustomerAdminAccountList from './Partial/CustomerAdminAccountList.jsx';
import CustomCheckbox from '../../components/CustomFields/CustomCheckbox.jsx';
import ldsApi from "../../api/ldsApi.jsx";

import { Row, Col } from 'react-bootstrap';

import Tour from 'reactour'


export class CustomersForm extends Component {
  static contextType = AuthContext;

  constructor(props){
    super(props);

    let id = (this.props.location && this.props.location.state && this.props.location.state.id && this.props.location.state.id > 0) ? this.props.location.state.id : 0;

    this.state = {
      id: id,

      isLoading: false,

      company_name: '',
      company_nameValidated: false,
      company_code: '',
      company_codeValidated: false,
      is_active: true,
      addresses: [],
      departments: [],
      customer_info: [],
      fms_checked: true,
      wms_checked: false,
      contact_no1: '',
      billing_frequency: '',
      billing_email: '',
      isTourOpen: false,
      openSkipDialog: false,
      standard_rate: {},
      project_rate: {},
      location_surcharge: {},
      parckage_surcharge: {},
      day_surcharge: {},
      service_surcharge: {},
    }
  }
  

  componentDidMount() {
    const { isOnBoarding } = this.context;

    if(this.state.id && this.state.id > 0){
      this.callDetailsApi(this.state.id, (data) => {
        let addresses = (data && data.customer_addresses && data.customer_addresses.length > 0) ? data.customer_addresses : [];
        if(addresses && addresses.length > 0){
          addresses = addresses.map((item, i) => {
            item['uuid'] = uuid();
            item['remove'] = false;
            return item;
          });
        }   
        
        let customer_info = (data.admins && data.admins.length > 0) ? data.admins : [];
        if(customer_info && customer_info.length > 0){
          customer_info = customer_info.map((item, i) => {
            item['uuid'] = uuid();
            item['remove'] = false;
            return item;
          });
        }

        let departments = (data.departments && data.departments.length > 0) ? data.departments : [];
        if(departments && departments.length > 0){
          departments = departments.map((item, i) => {
            item['uuid'] = uuid();
            item['department_name'] = item.name;
            item['department_id'] = item.id;
            item['delete'] = false;

            if(item.contact_people && item.contact_people.length > 0){
              item.contact_people = item.contact_people.map((subItem, j) => {
                subItem['uuid'] = uuid();
                subItem['delete'] = false;
                return subItem;
              });
            }

            return item;
          });
        }

        let application_registrations = (data.application_registrations && data.application_registrations.length > 0 )? data.application_registrations: [];

        let wms_checked = false
        if (application_registrations.length > 0) {
          application_registrations.forEach(dd => {
              
              if(dd.id == 2) {
                wms_checked = true
              }
          })
        }
        let customer_rates = (data.customer_rates && data.customer_rates.length > 0) ? data.customer_rates : [];
        if (customer_rates.length > 0) {
          let standard_rate = customer_rates[0].standard_rate ? JSON.parse(customer_rates[0].standard_rate) : {}
          let project_rate = customer_rates[0].project_rate ? JSON.parse(customer_rates[0].project_rate) : {}
          let parckage_surcharge = customer_rates[0].parckage_surcharge ? JSON.parse(customer_rates[0].parckage_surcharge) : {}
          let location_surcharge = customer_rates[0].location_surcharge ? JSON.parse(customer_rates[0].location_surcharge) : {}
          let service_surcharge = customer_rates[0].service_surcharge ? JSON.parse(customer_rates[0].service_surcharge) : {}
          let day_surcharge = customer_rates[0].day_surcharge ? JSON.parse(customer_rates[0].day_surcharge) : {}
          let customer_rate_id = customer_rates[0].id
          this.setState ({
            standard_rate,
            project_rate,
            parckage_surcharge,
            location_surcharge,
            service_surcharge,
            day_surcharge,
            customer_rate_id
          })
        }
        


        this.setState({
          company_name: data.company_name,
          company_code: data.company_code,
          contact_no1: data.contact_no1 && data.contact_no1.length == 8 ? "+65" + data.contact_no1 : data.contact_no1,
          billing_frequency:data.billing_frequency,
          billing_email: data.company_email,
          is_active: data.is_active,
          addresses: addresses,
          customer_info: customer_info,
          departments: departments,
          wms_checked: wms_checked
        });
      });
    }

    if(isOnBoarding){
      this.setState({
        isTourOpen: true,
      });
    }
  }


  checkIsMainExists = (addresses) => {
    if(addresses && addresses.length > 0){
        let isMain = addresses.filter(x => !x.remove).filter(x => x.is_main === true);

        return (isMain && isMain.length > 0) ? true : false;
    }

    return false;
  }


  /* API */
  callDetailsApi = (id = '', callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
      wmsApi.read('customers/' + id, null, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback((data && data.customer) ? data.customer : null);
              }
            });
          }, (error, type) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback(null);
              }
            });
          });
      });
    });
  }

  callCreateApi = (row, callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
      wmsApi.create('customers', row, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback(data);
              }
            });
          }, (error, type) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback();
                apiUtil.toast(error, 'check_circle',  'error');
              }
            });
          });
      });
    });
  }

  callUpdateApi = (id, row, callback = null) => {
    const { accessToken } = this.context;

    this.setState({
      isLoading: true
    }, () => {
      wmsApi.update('customers/' + id, row, accessToken)
        .then((result) => {
          apiUtil.parseResult(result, (data) => {
            this.setState({
              isLoading: false,
            }, () => {
              if(callback){
                callback();
                this.props.history.push('/customers');
              }
            });
          }, (error, type) => {
            this.setState({
              isLoading: false,
            }, () => {
              apiUtil.toast(
                error, 
                'check_circle'
              )
            });
          });
      });
    });
  }
  /* END API */


  /* STICKY PAGE HEADER */
  customStickyPageHeader = () => {
    const { isOnBoarding } = this.context;

    return <Box clone pl={4} pr={4} height={'100%'} alignItems={'center'}>
      <Grid container>
        {(!isOnBoarding) && <Box clone>
          <Grid item xs={'auto'}>
                <IconButton 
                    onClick={() => {
                        this.props.history.push('/customers');
                    }}
                >
                    <CloseIcon />
                </IconButton>
          </Grid>
        </Box>}
        {(!isOnBoarding) && <Box clone>
          <Grid item xs={'auto'}>
                <Divider orientation={'vertical'} />
          </Grid>
        </Box>}
        <Box clone>
          <Grid item xs={isOnBoarding ? 'auto' : true}>
            <CustomLabel
                className={'no-margin'}
                label={(this.state.id > 0) ? 'Edit Customer' : 'Add New Customer'}
                weight={'bold'}
                size={'md'}
            />
          </Grid>
        </Box>
        {isOnBoarding && <Box clone pr={1}>
          <Grid item xs={12} sm={true}>
            {this.setStepper()}
          </Grid>
        </Box>}
        <Box clone>
          <Grid item xs={'auto'}>
            <CustomButton 
              className={'create-customer-step'}
              type={'submit'}
              color={'secondary'}
              isLoading={this.state.isLoading}
            >
              <Box pl={2} pr={2}>Submit</Box>
            </CustomButton>
          </Grid>
        </Box>
      </Grid>
    </Box>
  }
  /* END STICKY PAGE HEADER */


  /* FORM */
  customerInformationForm = () => {
    return <Box pb={5}>
        <Grid container>
            <Grid item xs={12}>
                <CustomLabel
                    label={'Customer Information'}
                    weight={'bold'}
                    size={'md'}
                />
                <Divider light />
            </Grid>
            <Grid item xs={12}>
                <Container maxWidth={'xs'}>
                    <Box clone pt={5}>
                        <Grid container>

                            <Box clone>
                                <Grid item xs={12}>
                                    <CustomInput
                                        label={'Company Name'}
                                        placeholder={'Enter company name'}
                                        value={this.state.company_name}
                                        error={this.state.company_nameValidated}
                                        required={true}
                                        autoFocus={true}
                                        onChange={(e) => {
                                            this.setState({
                                              company_name: e.target.value,
                                              company_nameValidated: (e.target.value !== '') ? false : true,
                                            });
                                        }}
                                    />
                                </Grid>
                            </Box>

                            <Box clone>
                                <Grid item xs={12}>
                                    <CustomInput
                                        label={'Company Code'}
                                        placeholder={'Enter company code'}
                                        value={this.state.company_code}
                                        error={this.state.company_codeValidated}
                                        required={true}
                                        autoFocus={true}
                                        onChange={(e) => {
                                            this.setState({
                                              company_code: e.target.value,
                                              company_codeValidated: (e.target.value !== '') ? false : true,
                                            });
                                        }}
                                    />
                                </Grid>
                            </Box>
                            
                            <Box clone pb={2}>
                                <Grid item xs={12}>
                                    <CustomLabel
                                        label={'Customer Status'}
                                        labelComponent={<CustomTooltip title={'Disable your customers temporary by setting then to incative.'} />}
                                    />
                                </Grid>
                            </Box>
                            
                            <Box clone pr={{ xs: 0, md: 2 }} pb={{ xs: 2, md: 0 }}>
                                <Grid item xs={12} md={6}>
                                    <CustomButton 
                                        className={'outlined-default-primary ' + (this.state.is_active ? 'active' : '')}
                                        variant={'outlined'}
                                        color={'primary'}
                                        fullWidth={true}
                                        onClick={() => {
                                            this.setState({
                                                is_active: true
                                            });
                                        }}
                                    >
                                        Activate Customer
                                    </CustomButton>
                                </Grid>
                            </Box>
                            
                            <Box clone>
                                <Grid item xs={12} md={6}>
                                    <CustomButton 
                                        className={'outlined-default-primary ' + (!this.state.is_active ? 'active' : '')}
                                        variant={'outlined'}
                                        color={'secondary'}
                                        fullWidth={true}
                                        onClick={() => {
                                            this.setState({
                                                is_active: false
                                            });
                                        }}
                                    >
                                        Disable Customer
                                    </CustomButton>
                                </Grid>
                            </Box>
                            <Box clone mt={3}>
                                  <Grid item xs={12}>
                                      <Grid container>
                                          <Box clone>
                                              <Grid item xs={'auto'}>
                                                  <CustomCheckbox
                                                      label={'FMS'}
                                                      checked={this.state.fms_checked}
                                                      className={"checkbox-disabled-ignore"}
                                                      disabled={true}
                                                      // onChange={(checked) => {
                                                      //     this.setState({
                                                      //         fms_checked: checked,
                                                      //     });
                                                      // }}
                                                  />
                                              </Grid>
                                          </Box>
                                          <Box clone>
                                              <Grid item xs={'auto'}>
                                                  <CustomCheckbox
                                                      label={'WMS'}
                                                      checked={this.state.wms_checked}
                                                      onChange={(checked) => {
                                                          this.setState({
                                                              wms_checked: checked,
                                                          });
                                                      }}
                                                  />
                                              </Grid>
                                          </Box>
                                      </Grid>
                                  </Grid>
                              </Box>

                        </Grid>
                    </Box>
                </Container>
            </Grid>
        </Grid>
    </Box>
  }
  /* END FORM */

  customerRateForm = () => {
    return <Box >
          <Box pb={3}>
            <Grid item xs={12}>
                <CustomLabel
                    label={'Standard Rates'}
                    weight={'bold'}
                    size={'md'}
                />
                <Divider light />
            </Grid>
            <Row className="py-3">
              
              <Row className="d-flex justify-content-center align-items-center">
                <Col xs={2} className="d-flex align-items-center justify-content-center"></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center">Next Day</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center">Same Day</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center">Next Day (3H Slot)</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center">Express 2H</Col>
              </Row>
              <Row className="d-flex justify-content-center align-items-center">
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2 rounded">XS</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.xs_next_day ? this.state.standard_rate.xs_next_day: ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.xs_next_day = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.xs_same_day ? this.state.standard_rate.xs_same_day : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.xs_same_day = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.xs_next_day_3h ? this.state.standard_rate.xs_next_day_3h : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.xs_next_day_3h = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.xs_express_2h ? this.state.standard_rate.xs_express_2h : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.xs_express_2h = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
              </Row>
              <Row className="d-flex justify-content-center align-items-center">
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2 rounded">S</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.s_next_day ? this.state.standard_rate.s_next_day : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.s_next_day = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.s_same_day ? this.state.standard_rate.s_same_day : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.s_same_day = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.s_next_day_3h ? this.state.standard_rate.s_next_day_3h : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.s_next_day_3h = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.s_express_2h ? this.state.standard_rate.s_express_2h : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.s_express_2h = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
              </Row>
              <Row className="d-flex justify-content-center align-items-center">
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2 rounded">M</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.m_next_day ? this.state.standard_rate.m_next_day : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.m_next_day = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.m_same_day ? this.state.standard_rate.m_same_day : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.m_same_day = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.m_next_day_3h ? this.state.standard_rate.m_next_day_3h : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.m_next_day_3h = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.m_express_2h ? this.state.standard_rate.m_express_2h : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.m_express_2h = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
              </Row>
              <Row className="d-flex justify-content-center align-items-center">
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2 rounded">L</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.l_next_day ? this.state.standard_rate.l_next_day : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.l_next_day = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.l_same_day ? this.state.standard_rate.l_same_day : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.l_same_day = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.l_next_day_3h ? this.state.standard_rate.l_next_day_3h : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.l_next_day_3h = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.standard_rate.l_express_2h ? this.state.standard_rate.l_express_2h : ''}
                onChange={(e) => {
                  let standard_rate = this.state.standard_rate
                  standard_rate.l_express_2h = e.target.value
                  this.setState({
                    standard_rate: standard_rate
                  })

                }}
                /></div></Col>
              </Row>
            </Row>

            </Box>
            <Box pb={3}>
            <Grid item xs={12}>
                <CustomLabel
                    label={'Project Rates'}
                    weight={'bold'}
                    size={'md'}
                />
                <Divider light />
            </Grid>
            <Row className="py-3">
              <Row className="d-flex justify-content-center align-items-center">
                <Col xs={2} className="d-flex align-items-center justify-content-center"></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center">Next Day</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center">Same Day</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center">Next Day (3H Slot)</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center">Express 2H</Col>
              </Row>
              <Row className="d-flex justify-content-center align-items-center">
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2 rounded">XS</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.xs_next_day ? this.state.project_rate.xs_next_day : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.xs_next_day = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.xs_same_day ? this.state.project_rate.xs_same_day : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.xs_same_day = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.xs_next_day_3h ? this.state.project_rate.xs_next_day_3h : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.xs_next_day_3h = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.xs_express_2h ? this.state.project_rate.xs_express_2h : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.xs_express_2h = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
              </Row>
              <Row className="d-flex justify-content-center align-items-center">
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2 rounded">S</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.s_next_day ? this.state.project_rate.s_next_day : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.s_next_day = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.s_same_day ? this.state.project_rate.s_same_day : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.s_same_day = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.s_next_day_3h ? this.state.project_rate.s_next_day_3h : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.s_next_day_3h = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.s_express_2h ? this.state.project_rate.s_express_2h: ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.s_express_2h = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
              </Row>
              <Row className="d-flex justify-content-center align-items-center">
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2 rounded">M</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.m_next_day ? this.state.project_rate.m_next_day : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.m_next_day = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.m_same_day ? this.state.project_rate.m_same_day : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.m_same_day = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.m_next_day_3h ? this.state.project_rate.m_next_day_3h : '' }
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.m_next_day_3h = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.m_express_2h ? this.state.project_rate.m_express_2h : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.m_express_2h = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
              </Row>
              <Row className="d-flex justify-content-center align-items-center">
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2 rounded">L</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.l_next_day ? this.state.project_rate.l_next_day : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.l_next_day = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.l_same_day ? this.state.project_rate.l_same_day : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.l_same_day = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.l_next_day_3h ? this.state.project_rate.l_next_day_3h : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.l_next_day_3h = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center m-2"><div className="p-4"><input type="number" className="rounded form-control"
                value={this.state.project_rate.l_express_2h ? this.state.project_rate.l_express_2h : ''}
                onChange={(e) => {
                  let project_rate = this.state.project_rate
                  project_rate.l_express_2h = e.target.value
                  this.setState({
                    project_rate: project_rate
                  })

                }}
                /></div></Col>
              </Row>
            </Row>
            </Box>
            <Box pb={3}>
            <Grid item xs={12}>
                <CustomLabel
                    label={'Package Surcharge'}
                    weight={'bold'}
                    size={'md'}
                />
                <Divider light />
            </Grid>
            <Row className="py-3">
            <Row className="d-flex justify-content-start align-items-center">
                <Col xs={2} className="d-flex align-items-center justify-content-center">XS / S</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center"><input type="number" className="rounded form-control"
                value={this.state.parckage_surcharge.xs_s ? this.state.parckage_surcharge.xs_s : '' }
                onChange={(e) => {
                  let parckage_surcharge = this.state.parckage_surcharge
                  parckage_surcharge.xs_s = e.target.value
                  this.setState({
                    parckage_surcharge: parckage_surcharge
                  })

                }}
                /></Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center">M / L</Col>
                <Col xs={2} className="d-flex align-items-center justify-content-center"><input type="number" className="rounded form-control"
                value={this.state.parckage_surcharge.m_l ? this.state.parckage_surcharge.m_l : '' }
                onChange={(e) => {
                  let parckage_surcharge = this.state.parckage_surcharge
                  parckage_surcharge.m_l = e.target.value
                  this.setState({
                    parckage_surcharge: parckage_surcharge
                  })

                }}
                /></Col>
              </Row>
            </Row>
            </Box>
            <Box pb={3}>
            <Grid item xs={12}>
                <CustomLabel
                    label={'Location Surcharge'}
                    weight={'bold'}
                    size={'md'}
                />
                <Divider light />
            </Grid>
            <Row className="py-3">
              <Row>
              <Col xs={4} className="d-flex align-items-center">
                  <CustomLabel label={'Sentosa, Changi Airport, Tuas South (637, 636)'} className="w-50"/>
                  <input className="form-control"  type="number"
                  value={this.state.location_surcharge.sentosa_changi_airport ? this.state.location_surcharge.sentosa_changi_airport: '' }
                  onChange={(e) => {
                    let location_surcharge = this.state.location_surcharge
                    location_surcharge.sentosa_changi_airport = e.target.value
                    this.setState({
                      location_surcharge: location_surcharge
                    })
  
                  }}
                  />
              </Col>
              <Col xs={4} className="d-flex align-items-center">
                  <CustomLabel label={'Tuas (627,629,638,639)'} className="w-50"/>
                  <input className="form-control" type="number"
                  value={this.state.location_surcharge.tuas ? this.state.location_surcharge.tuas :''}
                  onChange={(e) => {
                    let location_surcharge = this.state.location_surcharge
                    location_surcharge.tuas = e.target.value
                    this.setState({
                      location_surcharge: location_surcharge
                    })
  
                  }}
                  />
              </Col>
              <Col xs={4} className="d-flex align-items-center">
                  <CustomLabel label={'CBD (01-08, 17-19, 22-23)'} className="w-50"/>
                  <input className="form-control" type="number" 
                  value={this.state.location_surcharge.cbd ? this.state.location_surcharge.cbd : ''}
                  onChange={(e) => {
                    let location_surcharge = this.state.location_surcharge
                    location_surcharge.cbd = e.target.value
                    this.setState({
                      location_surcharge: location_surcharge
                    })
  
                  }}
                  />
              </Col>
              </Row>
            </Row>
            </Box>
            <Box pb={3}>
            <Grid item xs={12}>
                <CustomLabel
                    label={'Day Surcharge'}
                    weight={'bold'}
                    size={'md'}
                />
                <Divider light />
            </Grid>
            <Row className="py-3">
              <Row>
              <Col xs={5} className="d-flex align-items-center">
                  <CustomLabel label={'Saturday or Eve of PH'} className="w-50"/>
                  <input className="form-control" type="number"
                  value={this.state.day_surcharge.saturday_or_eve_ph ? this.state.day_surcharge.saturday_or_eve_ph : ''}
                  onChange={(e) => {
                    let day_surcharge = this.state.day_surcharge
                    day_surcharge.saturday_or_eve_ph = e.target.value
                    this.setState({
                      day_surcharge: day_surcharge
                    })
  
                  }}
                  />
              </Col>
              </Row>
            </Row>
            </Box>
            <Box>
            <Grid item xs={12}>
                <CustomLabel
                    label={'Service Surcharge'}
                    weight={'bold'}
                    size={'md'}
                />
                <Divider light />
            </Grid>
            <Row className="py-3">
              <Row>
              <Col xs={4} className="d-flex align-items-center">
                  <CustomLabel label={'Waiting Time (every 10min)'} className="w-50"/>
                  <input className="form-control" type="number"
                  value={this.state.service_surcharge.waiting_time_10 ? this.state.service_surcharge.waiting_time_10 : '' }
                  onChange={(e) => {
                    let service_surcharge = this.state.service_surcharge
                    service_surcharge.waiting_time_10 = e.target.value
                    this.setState({
                      service_surcharge: service_surcharge
                    })
  
                  }}
                  />
              </Col>
              <Col xs={4} className="d-flex align-items-center">
                  <CustomLabel label={'Moving service (per headcount)'} className="w-50"/>
                  <input className="form-control" type="number"
                  value={this.state.service_surcharge.moving_service ? this.state.service_surcharge.moving_service: ''}
                  onChange={(e) => {
                    let service_surcharge = this.state.service_surcharge
                    service_surcharge.moving_service = e.target.value
                    this.setState({
                      service_surcharge: service_surcharge
                    })
  
                  }}
                  />
              </Col>
              </Row>

            </Row>
            </Box>
    </Box>
  }

  /* SUBMIT */
  handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const { isOnBoarding, setOnBoardingCustomer } = this.context;

    this.setState({
        isLoading: true,
    });

    const form = e.currentTarget;


    this.setState({
      company_nameValidated: false,
      company_codeValidated: false,
    });
    

    if(this.state.company_name === ''){
      this.setState({
        company_nameValidated: true
      });
    }
    if(this.state.company_code === ''){
      this.setState({
        company_codeValidated: true
      });
    }
    
    if(this.state.addresses.length > 0 && (this.state.addresses[0].name == "" || this.state.addresses[0].name == null)) {
      this.setState({
        isLoading: false
      }, () => {
        apiUtil.toast('You must fill company address label!');
      });        
      return;
    }
    
    if(this.state.addresses.length > 0 && (this.state.addresses[0].contact_no == "" || this.state.addresses[0].contact_no == null)) {
      this.setState({
        isLoading: false
      }, () => {
        apiUtil.toast('You must fill company address phone number!');
      });        
      return;
    }
    
    if(this.state.customer_info.length > 0 && (this.state.customer_info[0].last_name == "" || this.state.customer_info[0].last_name == null)) {
      this.setState({
        isLoading: false
      }, () => {
        apiUtil.toast('You must fill customer admin last name!');
      });        
      return;
    }
    
    
    
    if(!this.checkIsMainExists(this.state.addresses)){
      this.setState({
        isLoading: false
      }, () => {
        apiUtil.toast('Please choose a primary address for the client!');
      });
      return;
    }


    if (form.checkValidity() === true) {
      let application_registration_ids = ''
      if (this.state.fms_checked) {
        application_registration_ids += 1 +','
      }
      if (this.state.wms_checked) {
        application_registration_ids += 2 +','
      }
      let standard_rate = JSON.stringify(this.state.standard_rate)
      let project_rate = JSON.stringify(this.state.project_rate)
      let parckage_surcharge = JSON.stringify(this.state.parckage_surcharge)
      let location_surcharge = JSON.stringify(this.state.location_surcharge)
      let day_surcharge = JSON.stringify(this.state.day_surcharge)
      let service_surcharge = JSON.stringify(this.state.service_surcharge)
      // let customer_rate = [{standard_rate, project_rate, parckage_surcharge, location_surcharge, day_surcharge, service_surcharge, id: this.state.customer_rate_id}]
      let data = {
        company_name: this.state.company_name ? this.state.company_name.trim() : this.state.company_name ,
        company_code: this.state.company_code ? this.state.company_code.trim() : this.state.company_code ,
        contact_no1: this.state.contact_no1 && this.state.contact_no1.length == 8 ? "+65" + this.state.contact_no1.trim() : (this.state.contact_no1 ? this.state.contact_no1.trim() : this.state.contact_no1 ),
        company_email: this.state.billing_email ? this.state.billing_email.trim() : this.state.billing_email ,
        billing_frequency: this.state.billing_frequency,
        is_active: this.state.is_active,
        addresses: this.state.addresses ,
        departments: this.state.departments,
        application_registration_ids: application_registration_ids,
        // customer_info: this.state.customer_info,
        // customer_rate: customer_rate,
      };

      if(this.state.id && this.state.id > 0){
        this.callUpdateApi(this.state.id, data, () => {
          if(data) {
    
            let filter_customer = this.state.customer_info.filter(x => !x.remove && x.id);
            
            if(filter_customer.length > 0){
              let is_update_data = filter_customer.filter(x=> !x.permanent_delete);
              if(is_update_data.length > 0 ) {
                is_update_data.map((cus_info)=> {
                  this.updateCustomerAccount(cus_info, (data) => {
                    if(data.status == false) {
                      delete data.status;
                      let error = JSON.stringify(data);
                      apiUtil.toast(error, 'check_circle', 'error');
                    } else {
                      this.setState({
                        isLoading: false
                      }, () => {
                        this.props.history.push('/customers');
                        apiUtil.toast('Successfully Updated', 'check_circle');
                      });
                    }
                  })
                })
                
               
              } 
                let is_delete_data = filter_customer.filter(x=> x.permanent_delete);
                if(is_delete_data.length > 0 ) {
                  is_delete_data.map((cus_info)=> {
                  this.deleteCustomerAccount(cus_info, (data) => {                  
                  })
                })
              }

              
            } 
            let new_customer = this.state.customer_info.filter(x => !x.id  && !x.permanent_delete);
            if (new_customer.length > 0) {
              new_customer.map((cus_info) => {
                let account_data = {...cus_info,
                  "is_default_password": true, 
                  "password": "password", 
                  "is_lds_only": true, 
                  "is_own_data_only": true, 
                  "is_system_role": true,
                  "is_customer_admin": true,
                  "customer_id": this.state.id.toString()
                  };
                this.createCustomerAccount(account_data, (data) => {
                  if(data.status == false) {
                    apiUtil.toast(cus_info.email + " exist. Please use another email.", 'check_circle', 'error');
                  } else {
                      apiUtil.toast(cus_info.email + "'s Account has been successfully created", 'check_circle');
                  }
                  
                })
              })
              this.setState({
                isLoading: false
              }, () => {
                this.props.history.push('/customers');
              });
            }    
          }
          apiUtil.toast('Successfully Updated', 'check_circle');
        });
      } else {
        if(data && data.addresses && data.addresses.length > 0){
          data.addresses = data.addresses.filter(x => !x.remove);
        }  
    
        if(data && data.departments && data.departments.length > 0){
          data.departments = data.departments.filter(x => !x.delete).map((item, i) => {
            item.contact_people = item.contact_people.filter(x => !x.delete);
            return item;
          });
        }

        if(!isOnBoarding){
          // this.callCreateApi((data, result) => {

          this.callCreateApi(data, (result) => {
            if(result) {
              if(this.state.customer_info.length > 0) {
                this.state.customer_info.map((cus_info)=> {
                let account_data = {...cus_info,
                  "is_default_password": true, 
                  "password": "password", 
                  "is_lds_only": true, 
                  "is_own_data_only": true, 
                  "is_system_role": true,
                  "is_customer_admin": true,
                  "customer_id": result.customer.id.toString()
                  };
                  this.createCustomerAccount(account_data, (data) => {
          
                    if(data.status == false) {
                      apiUtil.toast(cus_info.email + " exist. Please use another email.", 'check_circle', 'error');
                    } else {
                        apiUtil.toast(cus_info.email + "'s Account has been successfully created", 'check_circle');
                    }
                })
                this.setState({
                  isLoading: false
                }, () => {
                  this.props.history.push('/customers');
                });
                })
              } else {
                this.props.history.push('/customers');
                apiUtil.toast('Successfully Created', 'check_circle');
              }
              
            } else {
              this.setState({
                isLoading: false
              }, () => {
                // this.props.history.push('/customers');
              });
            }
            
            
          });
        } else {
          setOnBoardingCustomer(JSON.stringify(data));
          this.props.history.push('/resources/vehicle');
          apiUtil.toastOnBoarding('Successfully Created', 'check_circle');
        }
      }
    } else {
      this.setState({
        isLoading: false
      });
    }
  }
  /* END SUBMIT */
  createCustomerAccount = ( row, callback = null) => {
    // this.state.isLoading(true);
    const { accessToken } = this.context;
    Api.createCustomerAccount('admins', row, accessToken)
    .then((result) => {
        apiUtil.parseResult(result, (data) => {
            // this.state.isLoading(false);       
            if(callback) {
                callback(data.result);
            }
        }, (error, type) => {
            // this.state.isLoading(false);
            if(callback) {
              // console.log(error);
                callback({status: false, ...error});
            }
        });
    }).catch(
        error => {
          // console.log(error)
        }
    )
  }
  
  checkExistOrders = (admin_id,callback=null) => {
    const { accessToken } = this.context;
    
        
    let param = {
      admin_id: admin_id
    };  

    ldsApi.read('/check-exist-client-order', param, accessToken)
      .then((result) => {
        apiUtil.parseResult(result, (data) => {

          if(callback){
            callback(data);
          }

        }, (error, type) => {
          apiUtil.toast(error,  'warning', 'error');
        });
    });
  }
  
  updateCustomerAccount = ( row, callback = null) => {
    // this.state.isLoading(true);
    const { accessToken } = this.context;
    Api.updateCustomerAccount('admins/'+ row.id, row, accessToken)
    .then((result) => {
        apiUtil.parseResult(result, (data) => {
            if(callback) {
                callback(data.result);
            }
        }, (error, type) => {
            // console.log("error", error)
            if(callback) {
                callback({status: false, ...error});
            }
        });
    }).catch(
        error => console.log(error)
    )
  }
  deleteCustomerAccount = ( row, callback = null) => {
    // this.state.isLoading(true);
    const { accessToken } = this.context;
    Api.deleteCustomerAccount('admins/'+ row.id, {}, accessToken)
    .then((result) => {
      if(callback) {
        callback(result);
      }
    }).catch(
        error => {
          console.log(error);
          callback({status: false, ...error});
        }
       
    )
  }

  /* STEPPER */
  setStepper = () => {
    return <>
      <CustomGuideStepper
        activeStep={0}
        steps={[
          {
            label: 'Create Customer',
          },
          {
            label: 'Create Vehicle',
          },
          {
            label: 'Create Driver',
          },
          {
            label: 'Create Job',
          },
        ]}
        onClick={(index) => {
          if(index === 0){
            this.props.history.push('/customers');
          } else if(index === 1){
            this.props.history.push('/resources/vehicle');
          } else if(index === 2){
            this.props.history.push('/resources/transport-operator');
          } else if(index === 3){
            this.props.history.push('/job-list');
          }
        }}
      />
      <Box pb={2} textAlign={'center'}>Fill in the form and create a customer.</Box>
      <Box textAlign={'center'}>
        <CustomButton 
          color={'primary'}
          href={'/'}
          onClick={(e) => {
              e.preventDefault();

              this.setState({
                openSkipDialog: true,
              });
          }}
        >
          Skip All
        </CustomButton>
      </Box>
    </>
  }
  /* END STEPPER */

  /* TOUR */
  setTour = () => {
    return <>
      <Tour
        steps={[
          {
            selector: '.create-customer-step',
            content: <Box>
              <h2>Create Customer</h2>
              <p>Fill in the required data to create a customer.</p>
            </Box>,
          },
        ]}
        isOpen={this.state.isTourOpen}
        rounded={10}
        accentColor={'#007CDE'}     
          //  accentColor={'#64CCC9'}
        badgeContent={'#007CDE'}      
          // badgeContent={'#64CCC9'}
        showNumber={false}
        showNavigation={false}
        disableInteraction={true}
        prevButton={<></>}
        nextButton={<></>}
        lastStepNextButton={<></>}
        onRequestClose={() => {
          this.setState({
            isTourOpen: false,
          });
        }} />
    </>
  }
  /* END TOUR */

  /* SKIP DIALOG */
  skipDialog = () => {
    const { accessToken, setOnBoardingCustomer, setOnBoardingVehicle, setOnBoardingDriver, setOnBoardingJob } = this.context;

    return <CustomDialog 
      open={this.state.openSkipDialog}
      title={'End Tutorial'}
      btnCloseText={'No'}
      onClose={() => {
        this.setState({
          openSkipDialog: false,
        });
      }}
      onOk={() => {
        apiUtil.callUpdateAdminProfileApi(accessToken, (data) => {
          this.setState({
            openSkipDialog: false,
          }, () => {
            setOnBoardingCustomer(null);
            setOnBoardingVehicle(null);
            setOnBoardingDriver(null);
            setOnBoardingJob(null);

            apiUtil.toastOnBoarding('Done', 'check_circle');
            this.props.history.push('/');
          });
        });
      }}
    >
      <Box>Are you sure you want to end tutorial?</Box>
    </CustomDialog>
  }
  /* END SKIP DIALOG */


  render() {
    return <Container fluid>
        <form noValidate autoComplete="off" onSubmit={this.handleSubmit}>
            <StickyPageHeader isSmall={true}>
                {this.customStickyPageHeader()}
            </StickyPageHeader>
            
            <Container maxWidth="lg">
                {
                  (!this.state.isLoading)
                  ?
                  <Card className="custom-card-margin-x">
                    {this.customerInformationForm()}
                    
                    <CompanyAddressList 
                        items={this.state.addresses}
                        onAddNew={(data) => {
                            this.setState({
                              addresses: data,
                            });
                        }}
                        onEdit={(data) => {
                            this.setState({
                              addresses: data,
                            });
                        }}
                        onRemove={(data) => {
                            this.setState({
                              addresses: data,
                            });
                        }}
                    />
                     <CustomerAdminAccountList 
                        items={this.state.customer_info}
                        checkExistOrders={this.checkExistOrders}
                        onAddNew={(data) => {
                            this.setState({
                              customer_info: data,
                            });
                        }}
                        onEdit={(data) => {
                            this.setState({
                              customer_info: data,
                            });
                        }}
                        onRemove={(data) => {
                            this.setState({
                              customer_info: data,
                            });
                        }}
                    />
                    <CompanyDepartmentList 
                        items={this.state.departments}
                        onAddNew={(data) => {
                            this.setState({
                              departments: data,
                            });
                        }}
                        onEdit={(data) => {
                            this.setState({
                              departments: data,
                            });
                        }}
                        onRemove={(data) => {
                            this.setState({
                              departments: data,
                            });
                        }}
                    />
                    {/* {this.customerRateForm()} */}
                  </Card>
                  :
                  <Card className="custom-card-margin-x">
                    <Box display={'flex'} alignItems={'center'} justifyContent={'center'} height={'75vh'}>
                      <CircularProgress size={35} />
                    </Box>
                  </Card>
                }
            </Container>
            
        </form>

        {this.setTour()}
        {this.skipDialog()}
    </Container>
  }
}
